export const isBannedUrl = (url: string) => {
  const bannedList = [
    'lin.ee',
    'line.me',
    'kakao.com',
    'pf.kakao.com',
    'qr.kakao.com',
  ]

  // Excluding https://line.me/R/ti/p/%40zwn0406m  and https://lin.ee/2GU1q7f (yay official line account)
  const whiteListRegex = new RegExp(
    /https?:\/\/(line.me\/R\/ti\/p\/%40zwn0406m|lin.ee\/2GU1q7f)/g
  )
  if (whiteListRegex.test(url)) return false

  try {
    const { hostname } = new URL(url)
    return bannedList.includes(hostname)
  } catch (e) {
    return false
  }
}
